import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { financeSearchSchema } from '@/features/bill/index.ts'

export const Route = createFileRoute('/_authenticated/finance/')({
  validateSearch: financeSearchSchema.extend({ tab: z.enum(['groups', 'money']).catch('groups') }),
  beforeLoad: ({ search: { tab, ...search } }) => {
    const destinations = {
      groups: '/finance/groups',
      money: '/finance/money'
    } as const
    throw redirect({ to: destinations[tab], search, replace: true })
  }
})
